<template>
  <div>
    <header class="leftbar">
      <div class="leftbar__inner">
        <!-- <div
          class="d-flex flex-row sm:hidden xl:flex sm:flex-col w-full justify-around items-center mb-2"
          :class="{ 'pt-[18px]': !user }"
          v-if="!isUserAuth">
          <div class="leftbar__items">
            <router-link to="/about" class="leftbar__overlay-item text-foregroundPrimary">
              <ChannelIcon class="mr-2 w-[20px]" />
              About Us
            </router-link>
          </div>
          <BaseButton class="max-w-[100px] sign-in-button" @click="logIn">Sign in</BaseButton>
          <BaseButton class="max-w-[100px] sign-up-button" @click="signUp">Sign up</BaseButton>
          <SIWFButton style="margin-top: 10px" class="sign-up-button" width="105px" buttonText="SIWF" @click="siwf" />
        </div> -->
        <div
          v-if="isUserAuth && userdata"
          class="leftbar__nav w-full mt-6 hidden sm:flex justify-start flex-col items-start">
          <div
            v-for="links in navLinks.filter(el => !el.hidden)"
            :key="links.name"
            @click.prevent="toggleLink(links, links.id)"
            :class="{ 'min-[1025px]:hidden': links.name === 'Explore' }">
            <component
              :is="links.name === 'Post' ? 'div' : 'router-link'"
              :to="links.name !== 'Post' ? getLink(links) : undefined"
              class="leftbar__items flex mb-[20px]"
              :class="{
                'pointer-events-none': links.disabled,
                active: links.isActive,
                full__size: isFullMenuItems,
                'create-button': links.name === 'Post',
              }"
              @click="links.name === 'Post'">
              <div class="flex justify-center items-start" :class="{ 'ml-[16px]': links.name !== 'Post' }">
                <div class="w-[20px] h-[20px] relative">
                  <img :src="getIconPath(links).value" alt="icon" :class="{ 'bell-shake': links.id === 4 && isShaking }" />
                  <span 
                    v-if="links.id === 4 && unreadNotificationsCount > 0" 
                    class="absolute -top-2 -right-2 bg-red-500 text-white text-xs font-bold rounded-full min-w-[16px] h-[16px] flex items-center justify-center px-1 text-[10px]"
                  >
                    {{ unreadNotificationsCount > 99 ? '99+' : unreadNotificationsCount }}
                  </span>
                </div>
                <span
                  class="leftbar__label text-foregroundPrimary text-[16px] cursor-pointer"
                  :class="{
                    'mt-1': links.name === 'Home',
                    'hidden xl:block': !isFullMenuItems,
                    'd-block': isFullMenuItems,
                    'font-weight': links.isActive,
                    'create-label': links.name === 'Post',
                  }"
                  >{{ links.name }}</span
                >
                <div
                  v-if="links.id === 5"
                  class="bg-[#a3e635] text-[#000] p-1 text-[12px] rounded-[5px] ml-1 -mt-[1px] max-h-[15px] flex items-center">
                  <span>Beta</span>
                </div>
              </div>
            </component>
          </div>
        </div>
        <div
          v-if="userdata"
          class="leftbar__nav w-full mt-[12px] mb-[10px] flex sm:hidden justify-between items-center">
          <div
            v-for="links in navLinks.filter(el => !el.hiddenForMobile)"
            :key="links.name"
            @click.prevent="toggleLink(links, links.id)">
            <div
              v-if="links.name === 'Post'"
              class="leftbar__items flex content-center items-center create-button-mobile"
              :class="{ active: links.isActive }">
              <img class="cursor-pointer" :src="getIconPath(links).value" alt="icon" />
            </div>
            <router-link
              v-else
              :to="links.src"
              class="leftbar__items flex content-center items-center relative"
              :class="{ 'pointer-events-none': links.disabled, active: links.isActive }">
              <div class="relative">
                <img class="cursor-pointer" :src="getIconPath(links).value" alt="icon" :class="{ 'bell-shake': links.id === 4 && isShaking }" />
                <span 
                  v-if="links.id === 4 && unreadNotificationsCount > 0" 
                  class="absolute -top-2 -right-2 bg-red-500 text-white text-xs font-bold rounded-full min-w-[16px] h-[16px] flex items-center justify-center px-1 text-[10px]"
                >
                  {{ unreadNotificationsCount > 99 ? '99+' : unreadNotificationsCount }}
                </span>
              </div>
              <div
                v-if="links.id === 5"
                class="bg-[#a3e635] text-[#000] p-[2px] text-[10px] rounded-[4px] absolute -top-1 right-1 flex items-center">
                <span>Beta</span>
              </div>
            </router-link>
          </div>
          <div class="flex justify-center items-center cursor-pointer relative">
            <button
              class="leftbar__items leftbar__items-mobile h-[24px] text-foregroundPrimary"
              @click.stop="toggleLeftbarOverlay">
              <MenuIcon />
            </button>
            <div
              v-show="isLeftbarOverlayVisible"
              @click="closeLeftbarOverlay"
              class="leftbar__overlay flex flex-col text-sm">
              <RouterLink to="/about" class="leftbar__overlay-item">
                <ChannelIcon class="mr-2 w-[20px]" />
                About Us
              </RouterLink>
              <RouterLink to="/profile/66ec8452e2fecf304bbc051b" class="leftbar__overlay-item">
                <lightBulbIcon class="mr-2 w-[20px]" />
                Help
              </RouterLink>
            </div>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>

<script setup>
import { computed, onMounted, onUnmounted, ref, watch, watchEffect } from 'vue';

import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';

import ChannelIcon from '@/components/Icons/ChannelIcon.vue';
import LightBulbIcon from '@/components/Icons/LightBulbIcon.vue';
import MenuIcon from '@/components/Icons/MenuIcon.vue';
import AboutUsLink from '@/components/Leftbar/AboutUsLink.vue';
import SIWFButton from '@/components/ui-kit/SIWFButton/index.vue';
import { environment } from '@/global/baseUrls.js';
import { setDefaultTab } from '@/utils/activeTabUtils';
import { useSchemeObserver } from '@/utils/colorSchemeUtils.js';
import eventBus from '@/utils/eventBus';
import { scrollToTop } from '@/utils/scrollControl';

const store = useStore();
const router = useRouter();
const route = useRoute();
const currentScheme = useSchemeObserver();

const isLinkActive = link => {
  const path = route.fullPath;

  if (link.name === 'Home' && path === '/') return true;
  if (link.name === 'Explore' && path.startsWith('/search')) return true;
  if (link.name === 'Notifications' && path.startsWith('/notifications')) return true;
  if (link.name === 'Help' && path.includes('/user/sezushelp')) return true;
  if (link.name === 'About Us' && path.startsWith('/about')) return true;
  if (link.name === 'Orgs/Groups' && path.startsWith('/orgs-groups')) return true;

  return false;
};

const logOut = payload => store.dispatch('logOut', payload);

//const getOnlyUserPosts = (payload) => store.dispatch("setOnlyUserPosts", { id: payload, limit: "1" });
const setShowModal = value => store.dispatch('showModal', value);
const setEditData = data => store.dispatch('addModalDataToState', data);
const setIsReply = value => store.dispatch('setIsReply', value);
const user = localStorage.getItem('user');
const isShowModal = computed(() => store.getters.getShowModalStatus);
const isUserAuth = computed(() => store.getters.getAuthStatus);
const userdata = computed(() => store.getters.getUser);
const environments = ref(['https://dev.sez.us', 'https://stg.sez.us', 'https://sez.us']);
const isFullMenuItems = ref(false);

const unreadNotificationsCount = computed(() => store.getters.getUnreadNotificationsCount);
const isShaking = ref(false);

// Trigger shake animation
const triggerShake = () => {
  isShaking.value = true;
  setTimeout(() => {
    isShaking.value = false;
  }, 500);
};

const userRoute = computed(() => {
  return `/user/sezushelp`;
});

const navLinks = ref([
  {
    icon: 'Home.svg',
    id: 1,
    iconActive: 'Homefill.svg',
    name: 'Home',
    src: '/',
    isActive: false,
    disabled: false,
    hidden: false,
    hiddenForMobile: false,
  },
  {
    icon: 'Search.svg',
    iconActive: 'Search.svg',
    name: 'Explore',
    id: 2,
    src: '/search',
    isActive: false,
    disabled: false,
    hidden: false,
    hiddenForMobile: false,
  },
  {
    id: 3,
    icon: 'Channel.svg',
    iconActive: 'Channel.svg',
    name: 'About Us',
    src: '/about',
    isActive: false,
    disabled: false,
    hidden: false,
    hiddenForMobile: true,
  },
  {
    id: 4,
    icon: 'Alert.svg',
    iconActive: 'Alertfill.svg',
    name: 'Notifications',
    src: '/notifications',
    isActive: false,
    disabled: false,
    hidden: false,
    hiddenForMobile: true,
  },
  {
    id: 5,
    icon: 'Groups.svg',
    iconActive: 'Groupsfill.svg',
    name: 'Groups',
    src: '/orgs-groups',
    isActive: false,
    disabled: false,
    hidden: false,
    hiddenForMobile: false,
  },
  {
    id: 6,
    icon: 'lightbulb.svg',
    iconActive: 'lightbulb.svg',
    name: 'Help',
    src: userRoute,
    isActive: false,
    disabled: false,
    hidden: false,
    hiddenForMobile: true,
  },
  {
    id: 7,
    icon: 'Create.svg',
    iconActive: 'Create.svg',
    name: 'Post',
    isActive: false,
    disabled: false,
    hidden: false,
    hiddenForMobile: false,
  },
]);

const getIconPath = link => {
  return computed(() => {
    const scheme = currentScheme.value;
    if (link.name === 'Post') {
      // For the Create button, always use the dark icon, since the button background is light
      return `/icon/Create-dark.svg`;
    }
    
    // Special handling for notifications
    if (link.id === 4) {
      const hasMessages = unreadNotificationsCount.value > 0;
      if (link.isActive) {
        return hasMessages
          ? `/icon/alert-unread-fill${scheme === 'light' ? '-dark' : ''}.svg`
          : `/icon/Alertfill${scheme === 'light' ? '-dark' : ''}.svg`;
      } else {
        return hasMessages
          ? `/icon/alert-unread${scheme === 'light' ? '-dark' : ''}.svg`
          : `/icon/Alert${scheme === 'light' ? '-dark' : ''}.svg`;
      }
    }
    
    return link.isActive
      ? `/icon/${link.iconActive.replace('.svg', scheme === 'light' ? '-dark.svg' : '.svg')}`
      : `/icon/${link.icon.replace('.svg', scheme === 'light' ? '-dark.svg' : '.svg')}`;
  });
};

const getLink = link => {
  if (!link.src) return;
  return link.src;
};

watch(
  unreadNotificationsCount,
  (newCount, oldCount) => {
    // Only shake if count increased (new notification arrived)
    if (newCount > oldCount && oldCount !== undefined) {
      triggerShake();
    }
  },
  { immediate: true },
);

onMounted(() => {
  navLinks.value.forEach(link => {
    link.isActive = isLinkActive(link);
  });
});

watch(route, () => {
  navLinks.value.forEach(link => {
    link.isActive = isLinkActive(link);
  });
});

// Watch for user authentication to shake on login if notifications exist
watch(
  () => userdata.value,
  (newUser, oldUser) => {
    // Trigger shake when user logs in and has unread notifications
    if (newUser && !oldUser && unreadNotificationsCount.value > 0) {
      // Delay slightly to ensure UI is ready
      setTimeout(() => {
        triggerShake();
      }, 1000);
    }
  }
);

watchEffect(() => {
  if (!isShowModal.value) {
    const createButton = navLinks.value.find(el => el.name === 'Post');
    if (createButton) createButton.isActive = false;

    // After closing the modal, restore the active state for the current route
    navLinks.value.forEach(link => {
      if (link.name !== 'Post') {
        link.isActive = isLinkActive(link);
      }
    });
  }
});

const toggleLink = async (item, id) => {
  // Enable animation immediately on click
  isFullMenuItems.value = true;

  // Any asynchronous actions after that
  if (item.name === 'Home') {
    eventBus.emit('set-default-tab');
    setTimeout(() => {
      scrollToTop();
    }, 100);
  }

  navLinks.value.forEach(el => (el.isActive = false));
  item.isActive = true;

  if (item.name === 'Post') {
    store.dispatch('getMe');
    setTimeout(() => {
      setIsReply(false);
      setEditData(null);
      setShowModal(true);
    }, 100);
    return;
  }
};

const logIn = () => {
  router.push('/sign-in');
  localStorage.removeItem('activeTab');
};
const signUp = () => {
  router.push('/onboarding/login-method');
};

const togglelogOut = () => {
  logOut();
};

const isLeftbarOverlayVisible = ref(false);
const toggleLeftbarOverlay = () => {
  isLeftbarOverlayVisible.value = !isLeftbarOverlayVisible.value;
};
const closeLeftbarOverlay = () => {
  isLeftbarOverlayVisible.value = false;
};
const closeLeftbarOverlayOnOutsideClick = event => {
  if (!event.target.closest('.leftbar__overlay')) {
    isLeftbarOverlayVisible.value = false;
  }
};
onMounted(() => {
  document.addEventListener('click', closeLeftbarOverlayOnOutsideClick);
});
onUnmounted(() => {
  document.removeEventListener('click', closeLeftbarOverlayOnOutsideClick);
});
</script>

<style lang="scss" scoped>
.leftbar__items {
  width: 60px;
  height: 40px;
  position: relative;
  z-index: 1;

  opacity: 0.5;
  display: flex;
  align-items: center;
  justify-content: start;
  cursor: pointer;

  &.active {
    opacity: var(--leftbar-menu-hover-opacity);
  }

  &.full__size {
    width: 160px;
  }

  &:hover {
    opacity: var(--leftbar-menu-hover-opacity);
  }
}

.leftbar__items-mobile {
  display: flex;
  align-items: center !important;
  justify-content: center;
}

.leftbar__label {
  margin-left: 10px;
  font-weight: 400;
}

.leftbar {
  height: fit-content;
  position: sticky;
  top: 80px;

  &__inner {
    @include container;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    position: sticky;
    top: 80px;
  }

  .nav-bar {
    width: 100%;
    background: transparent;

    &__inner {
      @include container;
      margin: 0 auto;
      height: 100%;
      display: flex;
      align-items: center;
      overflow: auto;

      &::-webkit-scrollbar {
        width: 0;
        height: 0;
        background-color: transparent;
      }

      scrollbar-color: transparent transparent;
      scrollbar-width: none;
    }

    &__items {
      position: relative;
      display: grid;
      grid-template-columns: 1fr 1fr;
      justify-items: center;
      grid-gap: 5px;
    }

    &__item {
      padding: 28px 0;
      color: #1390e5;
      transition: 0.2s ease-in-out;

      a {
        text-decoration: none;
      }

      span {
        display: block;
        color: #1390e5;
        text-decoration: none;
        transition: 0.2s ease-in-out;
        word-break: break-all;

        &:hover {
          opacity: 0.7;
        }
      }
    }

    &__shape {
      $tabsCount: 2;
      $pagePadding: 5px;
      margin: 0 $pagePadding;
      position: absolute;
      height: 2px;
      left: 0;
      bottom: 0;
      width: calc((100% / #{$tabsCount}) - #{$pagePadding * 2});
      background: #1390e5;
      transition: 0.3s ease-in-out;
    }
  }

  &__action {
    display: flex;
  }

  &__button {
    &_left {
      margin-right: 20px;
    }
  }

  @include _1279 {
    &__inner {
      padding: 0;
    }
  }

  @include _1024 {
    &__inner {
      padding-left: 29px;
    }
  }

  @include _767 {
    position: relative;
    top: auto;
    height: auto;
  }

  @include _639 {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: var(--background-primary);
    z-index: 1000;
    padding: 10px 16px;

    &__inner {
      padding-left: 0;
    }
  }

  @include _575 {
    &__button {
      font-size: 14px !important;
      padding: 0;
    }

    .nav-bar {
      &__item {
        padding: 15px 0;
        font-size: 12px;
      }
    }
  }
}

.leftbar__inner-active-menu {
  padding: 17px !important;
}

.leftbar__items::before {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0);
  z-index: -1;
  transition:
    background-color 0.3s ease,
    transform 0.3s ease;
}

.leftbar__items:hover::before {
  background-color: var(--background-secondary);
}

.leftbar__items.active::before {
  background-color: transparent;
}

.font-weight {
  font-weight: 700;
}

// .leftbar__items img,
// .leftbar__items svg {
//   width: 24px;
//   height: 24px;
// }

@media (min-width: 1280px) {
  .sign-in-button,
  .sign-up-button {
    margin-top: 15px;
  }

  .leftbar__nav {
    align-items: start;
  }

  .leftbar__items {
    width: 160px;
    height: 40px;
  }

  .create-button.leftbar__items {
    width: auto !important;
    padding: 6px 12px !important;
  }
}

@media (min-width: 1024px) and (max-width: 1279px) {
  .sign-in-button,
  .sign-up-button {
    margin-top: 5px;
  }
}

@media (max-width: 767px) {
  .sign-in-button,
  .sign-up-button {
    margin-top: 0;
  }
}

.create-button {
  margin-left: 6px;
  background-color: #a3e635;
  border-radius: 6px;
  opacity: 1 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  padding: 6px 12px;
  height: 36px;
  width: auto !important;

  &:hover {
    opacity: 0.9 !important;
    background-color: #95d130;
  }

  &::before {
    display: none;
  }

  .create-label {
    color: #000;
    font-weight: 500;
    margin-left: 6px !important;
  }

  img {
    filter: brightness(0);
  }

  &.full__size {
    width: auto !important;
  }
}

.create-button-mobile {
  background-color: #a3e635;
  border-radius: 6px;
  opacity: 1 !important;
  height: 28px !important;
  width: 40px !important;
  display: flex;
  justify-content: center;
  padding: 6px;

  &:hover {
    opacity: 0.9 !important;
    background-color: #95d130;
  }

  &::before {
    display: none;
  }

  img {
    width: 18px;
    height: 18px;
    filter: brightness(0);
  }
}
</style>
<style lang="scss">
.leftbar__overlay {
  position: absolute;
  bottom: calc(0% + 40px);
  right: calc(100% - 24px);
  background: var(--background-primary);
  border: 1.5px solid var(--color-scheme-switcher-dropdown-border);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.24);
  border-radius: 8px;
  padding: 8px 0;
  z-index: 1;

  &-item {
    height: 36px;
    width: 180px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: var(--foreground-primary);
    cursor: pointer;
    padding: 0 16px;
    box-sizing: border-box;
  }

  &-item:hover {
    background: var(--background-secondary);
  }
}

// .leftbar-desktop-anim {
//   @media (min-width: 640px) {
//     transition: margin-left 0.1s cubic-bezier(0.4, 0, 0.2, 1);
//     margin-left: 40px;
//   }
//   &--shifted {
//     @media (min-width: 640px) {
//       margin-left: -30px;
//     }
//   }
// }

@keyframes bellShake {
  0%, 100% { transform: rotate(0deg); }
  10% { transform: rotate(-10deg); }
  20% { transform: rotate(10deg); }
  30% { transform: rotate(-10deg); }
  40% { transform: rotate(10deg); }
  50% { transform: rotate(-5deg); }
  60% { transform: rotate(5deg); }
  70% { transform: rotate(-5deg); }
  80% { transform: rotate(5deg); }
  90% { transform: rotate(0deg); }
}

.bell-shake {
  animation: bellShake 0.5s ease-in-out;
}
</style>
